import React from 'react';
import styled from 'styled-components';

import type { CheckDepositBatch } from '@column/api';
import { Button, Icon } from '@column/column-ui-kit';

import { CheckScannerIcon } from '~/elements/icons/transfers/CheckScanner';
import { useBatchSheet } from '~/lib/transfers';
import { Card, Flex, Inner, Text } from '~/styles';
import { formatDate } from '~/util/getDateFormat';

import { Avatar, AvatarVariant } from './Avatar';

const StyledCard = styled(Card)`
  margin: 16px 0 0 28px;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin: 16px 0 0 0;
  }
`;

const ChildrenWrapper = styled.div`
  margin-left: -28px;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-left: auto;
  }
`;

const StyledFlex = styled(Flex)`
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    flex-direction: row;
    align-items: center;
    gap: 0;
  }
`;

export const BatchWrapper = ({ batch, children }: { batch: CheckDepositBatch; children: React.ReactNode }) => {
  const { openBatchSheet } = useBatchSheet();

  return (
    <StyledCard variant="dark">
      <Inner p={16} pb={0}>
        <StyledFlex>
          <Flex alignItems="center" gap={12}>
            <Avatar size="large" variant={AvatarVariant.Secondary}>
              <CheckScannerIcon />
            </Avatar>
            <Flex flexDirection="column" gap={4}>
              <Text as="h4" size={14} weight="medium">
                {batch.description}
              </Text>
              <Flex gap={8}>
                <Text as="h4" size={14} weight="medium" color="light">
                  {batch.total_count} Checks
                </Text>
                <Text as="h4" size={10} color="lighter">
                  •
                </Text>
                <Text as="h4" size={14} weight="medium" color="light">
                  {formatDate(batch.created_at)}
                </Text>
              </Flex>
            </Flex>
          </Flex>
          <Button
            icon={<Icon.ChevronRightLarge />}
            onClick={() => openBatchSheet(batch.id)}
            variant="muted"
            size="small"
            iconRight
          >
            View Batch
          </Button>
        </StyledFlex>
        <ChildrenWrapper>{children}</ChildrenWrapper>
      </Inner>
    </StyledCard>
  );
};
